import React, { useState } from "react";

function GRNForm() {
  const [grn, setGrn] = useState({
    grnNumber: "GRN-" + Date.now(), // Auto-generated unique GRN ID
    linkedPoNumber: "",
    receivedDate: new Date().toISOString().split("T")[0],
    itemsReceived: "",
    shortageExcess: "",
    damagedExpired: "",
    receivedBy: "",
    invoiceNumber: "",
    paymentStatus: "Pending",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setGrn({ ...grn, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("GRN Saved:", grn);
    alert("GRN saved successfully!");
  };

  const styles = {
    container: {
      padding: "30px",
      background: "#f9fafb",
      borderRadius: "12px",
      //maxWidth: "1000px",
      margin: "20px auto",
      boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
    },
    row: {
      display: "flex",
      gap: "20px",
      marginBottom: "20px",
      flexWrap: "wrap",
    },
    formGroup: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
    },
    label: {
      marginBottom: "6px",
      fontSize: "14px",
      fontWeight: "600",
      color: "#374151",
    },
    input: {
      padding: "12px 14px",
      borderRadius: "8px",
      border: "1.5px solid #d1d5db",
      fontSize: "14px",
      backgroundColor: "#ffffff",
      transition: "all 0.2s ease",
    },
    readOnlyInput: {
      padding: "12px 14px",
      borderRadius: "8px",
      border: "1.5px solid #d1d5db",
      fontSize: "14px",
      backgroundColor: "#f3f4f6",
      cursor: "not-allowed",
    },
    button: {
      marginTop: "20px",
      padding: "12px 24px",
      background: "linear-gradient(90deg, #16a34a, #15803d)",
      color: "#fff",
      border: "none",
      borderRadius: "8px",
      fontSize: "15px",
      fontWeight: "600",
      cursor: "pointer",
      boxShadow: "0 4px 10px rgba(22,163,74,0.3)",
    },
  };

  return (
    <div style={styles.container}>
      <h2
        style={{
          fontSize: "22px",
          marginBottom: "20px",
          fontWeight: "700",
          color: "#111827",
        }}
      >
        Goods Receipt Note (GRN) Form
      </h2>

      <form onSubmit={handleSubmit}>
        {/* Row 1 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>GRN No.</label>
            <input
              type="text"
              name="grnNumber"
              value={grn.grnNumber}
              readOnly
              style={styles.readOnlyInput}
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Linked PO No.</label>
            <input
              type="text"
              name="linkedPoNumber"
              value={grn.linkedPoNumber}
              onChange={handleChange}
              style={styles.input}
              placeholder="Enter Linked PO No."
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Received Date</label>
            <input
              type="date"
              name="receivedDate"
              value={grn.receivedDate}
              onChange={handleChange}
              style={styles.input}
            />
          </div>
        </div>

        {/* Row 2 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Items Received</label>
            <input
              type="text"
              name="itemsReceived"
              value={grn.itemsReceived}
              onChange={handleChange}
              style={styles.input}
              placeholder="Qty / Batch / Expiry"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Shortage / Excess</label>
            <input
              type="text"
              name="shortageExcess"
              value={grn.shortageExcess}
              onChange={handleChange}
              style={styles.input}
              placeholder="Auto-flag mismatches"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Damaged / Expired Items</label>
            <input
              type="text"
              name="damagedExpired"
              value={grn.damagedExpired}
              onChange={handleChange}
              style={styles.input}
              placeholder="Rejected stock"
            />
          </div>
        </div>

        {/* Row 3 */}
        <div style={styles.row}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Received By</label>
            <input
              type="text"
              name="receivedBy"
              value={grn.receivedBy}
              onChange={handleChange}
              style={styles.input}
              placeholder="Staff receiving stock"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Invoice / Bill No.</label>
            <input
              type="text"
              name="invoiceNumber"
              value={grn.invoiceNumber}
              onChange={handleChange}
              style={styles.input}
              placeholder="Invoice/Bill Number"
            />
          </div>
          <div style={styles.formGroup}>
            <label style={styles.label}>Payment Status</label>
            <select
              name="paymentStatus"
              value={grn.paymentStatus}
              onChange={handleChange}
              style={styles.input}
            >
              <option value="Pending">Pending</option>
              <option value="Partially Paid">Partially Paid</option>
              <option value="Paid">Paid</option>
            </select>
          </div>
        </div>

        <button type="submit" style={styles.button}>
           Save GRN
        </button>
      </form>
    </div>
  );
}

export default GRNForm;
